import { z } from "zod";
import { mediaListSchema } from "../common.js";

/**
 * Annotation interne — saisie réservée à l'équipe, hors rapport client (jamais
 * rendue dans le PDF).
 */
export const vtInternalSchema = z
  .object({
    // Signal pour le service client : coché quand le client a eu une bonne
    // expérience et peut être sollicité pour un avis. Lu par apps/notifier au
    // moment de la soumission d'une VT.
    solicitOpinion: z.boolean().optional(),
    observations: z.string().optional(),
    observationsMedia: mediaListSchema.optional(),
  })
  .partial();

export type VtInternal = z.infer<typeof vtInternalSchema>;
